import { render, staticRenderFns } from "./WinesAdd.vue?vue&type=template&id=e09513b2&scoped=true"
import script from "./WinesAdd.vue?vue&type=script&lang=js"
export * from "./WinesAdd.vue?vue&type=script&lang=js"
import style0 from "./WinesAdd.vue?vue&type=style&index=0&id=e09513b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09513b2",
  null
  
)

export default component.exports